module.exports = __webpack_public_path__ + "static/media/20ECE19.c41cf9c4.jpg";